















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import commonService from '@/services/common-services';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listPackage: any;
    private isCheckAll = false;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    get configuration() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
    }

    get productTypes()  {
        if (this.configuration && this.configuration.ProductTypes) {
            return JSON.parse(this.configuration.ProductTypes);
        }
        return [];
    }

    private getProductTypeName(value: number) {
        if (this.productTypes.length === 0) {
            return '';
        }

        const type = this.productTypes.find((p) => p.value === value);
        return type ? type.name : '';
    }


    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }

    private async created() {
        await this.getConfiguration();
    }

    private async getConfiguration() {
        const result = await commonService.configuration();
        if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
        }
    }
}
